import { sendTutorFeedback } from '../../services/tutorFeedbackApi';
import type { TutorFeedbackPayload, TutorFeedbackReason } from '../../services/tutorFeedbackApi';

/**
 * Tutor message feedback. Thin UI-facing wrapper over the real
 * POST /portal/tutor/messages/:messageId/feedback call (see
 * services/tutorFeedbackApi.ts). `messageId` MUST be the server-assigned id;
 * callers disable the controls while only a client id exists.
 */
export type { TutorFeedbackPayload, TutorFeedbackReason };

export async function submitTutorFeedback(
  messageId: string,
  payload: TutorFeedbackPayload,
): Promise<void> {
  await sendTutorFeedback(messageId, payload);
}
